import React, { useState } from "react";
import { AiFillFileAdd } from "react-icons/ai";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { RoutePath } from "../../utility/Constant";
import { FaRegEdit } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";

function SelectionCard({ project, user, handleSingleDelete, dragHandle }) {
  const { projectsContent, projectsContentAdd } = RoutePath;
  const [showMore, setShowMore] = useState(false);
  const [visibility, setVisibility] = useState(true);

  const handleDelete = async () => {
    const res = await handleSingleDelete(project._id);
    if (typeof res === "boolean" && res === true) {
      setVisibility(false);
    }
  };

  return (
    <>
      {visibility ? (
        <div className="group relative bg-white border md:min-h-[20rem] flex flex-col justify-between overflow-hidden shadow-lg rounded-lg">
          {project ? (
            <>
              <div>
                <figure className="relative">
                  {dragHandle && dragHandle}
                  <img
                    src={`${process.env.REACT_APP_API_URL}images/${project?.image_link?.url}`}
                    alt={project.project_title + " " + "Image"}
                    className="h-[120px] md:h-[180px] object-cover w-full"
                  />
                </figure>
                <div className="p-4 h-auto flex flex-col gap-1 justify-between">
                  <div className="w-full  transition-all duration-150">
                    <h2 className="text-lg font-semibold line-clamp-3">
                      {project.project_title}
                    </h2>

                    <p
                      className={`hidden md:block relative w-full text-gray-600 `}
                    >
                      {showMore
                        ? project.project_description
                        : `${project.project_description?.substring(0, 100)}`}
                    </p>
                    {/* show more and buttos style start */}
                    <div className="flex items-center justify-between mt-3 border-t pt-3">
                      <div className="hidden md:flex justify-end items-center">
                        <button
                          onClick={() => setShowMore((old) => !old)}
                          className="text-sm text-red-500 hover:text-[#DB0029]"
                        >
                          {project?.project_description?.length > 99 &&
                            (showMore ? "Show less" : "Show more")}
                        </button>
                      </div>
                      <div className=" flex  gap-2 text-xs md:text-base">
                        <Link
                          to={`/${projectsContent}/${project._id}`}
                          className="btn btn-outline btn-xs text-blue-500    transition duration-150 hover:text-blue-700 text-center rounded-lg"
                        >
                          <FaRegEdit size={20} />
                        </Link>
                        {user === "admin" && (
                          <button
                            id={project._id}
                            onClick={handleDelete}
                            className="btn btn-outline btn-xs  text-red-500   px-3 transition duration-150  text-center rounded-lg hover:text-red-700"
                          >
                            <MdDeleteForever size={23} />
                          </button>
                        )}
                      </div>
                    </div>

                    {/* show more and buttos style start */}
                  </div>
                </div>
              </div>
            </>
          ) : (
            <Link
              to={`/${projectsContentAdd}`}
              className="flex justify-center items-center rounded-xl bg-gray-50 shadow-xl h-full "
            >
              <p className="text-8xl group-hover:text-[#DB0029]">
                <AiFillFileAdd />
              </p>
            </Link>
          )}
        </div>
      ) : null}
    </>
  );
}

export default SelectionCard;
